<template>
  <div class="container p-4">
    <h3 class="text-xl font-bold mb-3">Habilidades (preguntas)</h3>
    <p class="text-sm text-600 mb-3">
      Catálogo de habilidades referenciadas por las preguntas (<strong>id_habilidad</strong>). Los formularios masivos mapean nombres a estos ids; mantén textos claros y consistentes.
    </p>

    <CardPrime class="mb-4">
      <template #title>Búsqueda</template>
      <template #content>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div>
            <label class="block text-sm mb-1">Glosa (contiene)</label>
            <InputText v-model="filtroGlosa" placeholder="Ej: Aplicar, Comprender…" class="w-full" @keyup.enter="cargarLista" />
          </div>
          <div class="field flex align-items-center gap-2">
            <CheckboxPrime v-model="incluirTodas" :binary="true" inputId="hab-todas" />
            <label for="hab-todas" class="text-sm">Incluir no vigentes</label>
          </div>
          <div class="flex gap-2 flex-wrap">
            <ButtonPrime label="Buscar" icon="pi pi-search" @click="cargarLista" />
            <ButtonPrime label="Nueva habilidad" icon="pi pi-plus" class="p-button-success" @click="abrirNuevo" />
          </div>
        </div>
      </template>
    </CardPrime>

    <DataTablePrime
      :value="habilidades"
      :loading="loading"
      class="p-datatable-sm"
      responsiveLayout="scroll"
      emptyMessage="Sin resultados"
    >
      <ColumnPrime field="Id" header="ID" />
      <ColumnPrime field="Glosa" header="Glosa" />
      <ColumnPrime header="Vigente">
        <template #body="{ data }">{{ data.Vigente ? 'Sí' : 'No' }}</template>
      </ColumnPrime>
      <ColumnPrime header="Acciones">
        <template #body="{ data }">
          <ButtonPrime icon="pi pi-pencil" class="p-button-sm p-mr-1" @click="abrirEditar(data)" />
          <ButtonPrime
            v-if="data.Vigente"
            label="Desactivar"
            class="p-button-sm p-button-warning"
            @click="desactivar(data)"
          />
        </template>
      </ColumnPrime>
    </DataTablePrime>

    <DialogPrime v-model:visible="dialogVisible" :modal="true" :header="dialogTitulo" :style="{ width: '480px' }">
      <div class="field mb-3">
        <label class="block mb-1">Glosa</label>
        <InputText v-model="form.Glosa" class="w-full" placeholder="Ej: Aplicar" />
      </div>
      <div class="field mb-3 flex align-items-center">
        <CheckboxPrime v-model="form.Vigente" :binary="true" inputId="hab-vig" />
        <label for="hab-vig" class="ml-2">Vigente</label>
      </div>
      <template #footer>
        <ButtonPrime label="Cancelar" class="p-button-secondary" @click="dialogVisible = false" />
        <ButtonPrime label="Guardar" @click="guardar" />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import CardPrime from 'primevue/card';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import DialogPrime from 'primevue/dialog';
import ButtonPrime from 'primevue/button';
import InputText from 'primevue/inputtext';
import CheckboxPrime from 'primevue/checkbox';
import HabilidadService from '@/services/HabilidadService';

export default {
  name: 'MantenedorHabilidades',
  components: {
    CardPrime,
    DataTablePrime,
    ColumnPrime,
    DialogPrime,
    ButtonPrime,
    InputText,
    CheckboxPrime,
  },
  data() {
    return {
      habilidades: [],
      loading: false,
      filtroGlosa: '',
      incluirTodas: false,
      dialogVisible: false,
      dialogTitulo: 'Habilidad',
      form: {
        Id: 0,
        Glosa: '',
        Vigente: true,
      },
    };
  },
  methods: {
    async cargarLista() {
      this.loading = true;
      try {
        const t = (this.filtroGlosa || '').trim();
        const params = {};
        if (t) params.glosa = t;
        if (this.incluirTodas) {
          params.todos = true;
        } else {
          params.vigente = true;
        }
        const r = await HabilidadService.listar(params);
        this.habilidades = r.data || [];
      } catch (e) {
        alert(e.response?.data?.Message || e.message || 'Error al cargar');
        this.habilidades = [];
      } finally {
        this.loading = false;
      }
    },
    abrirNuevo() {
      this.dialogTitulo = 'Nueva habilidad';
      this.form = {
        Id: 0,
        Glosa: '',
        Vigente: true,
      };
      this.dialogVisible = true;
    },
    abrirEditar(row) {
      this.dialogTitulo = 'Editar habilidad';
      this.form = {
        Id: row.Id,
        Glosa: row.Glosa || '',
        Vigente: row.Vigente !== false,
      };
      this.dialogVisible = true;
    },
    async guardar() {
      const glosa = (this.form.Glosa || '').trim();
      if (!glosa) {
        alert('Ingresa la glosa.');
        return;
      }
      const payload = {
        Id: this.form.Id || 0,
        Glosa: glosa,
        Vigente: !!this.form.Vigente,
      };
      try {
        if (payload.Id > 0) {
          await HabilidadService.actualizar(payload.Id, payload);
        } else {
          await HabilidadService.crear(payload);
        }
        this.dialogVisible = false;
        await this.cargarLista();
      } catch (e) {
        alert(e.response?.data?.Message || e.response?.data?.message || e.message || 'Error al guardar');
      }
    },
    async desactivar(row) {
      if (!confirm(`¿Desactivar la habilidad "${row.Glosa}" (id ${row.Id})?`)) return;
      const p = {
        Id: row.Id,
        Glosa: row.Glosa,
        Vigente: false,
      };
      try {
        await HabilidadService.actualizar(row.Id, p);
        await this.cargarLista();
      } catch (e) {
        alert(e.response?.data?.Message || e.message || 'Error');
      }
    },
  },
  async mounted() {
    await this.cargarLista();
  },
};
</script>
